module.exports = __webpack_public_path__ + "img/lot-slim.b28528c6.svg";